import React, { Component } from 'react'
import FeatureContent from './FeatureContent'

class Feature extends Component {
    render() {
        return (
            <div className='feature services' style={{backgroundColor: 'whitesmoke'}}>
                {
                    this.props.text 
                        ?   <div className='feature-text'>
                                <p>{this.props.text}</p>
                            </div>
                        : null
                }
                <h2 style={{fontSize:'25px',color:'#db6162', }}>
                        {this.props.name}
                </h2>
                <FeatureContent data={this.props.data}/>
            </div>
        )
    }
}

export default Feature


// WEBPACK FOOTER //
// ./src/components/pages/category/Feature.js